// @ts-check
import { createContext, useContext, useMemo } from "react";
import { useDataGridContextBase } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.hooks';

export const DataGridContext = createContext(null);

export function useDataGridContext() {
    return useContext(DataGridContext);
}

const defaultUseCustomContextValue = () => /** @type {any} */ ({});

/**
 * @template T
 * @param {string} dataGridName
 * @param {() => T} [useCustomContextValue]
 * @returns {[React.Context<BaseDataGridContextValue & T>, React.FC<{children: React.ReactNode}>]}
 */
export function createDataGridContext(dataGridName, useCustomContextValue=defaultUseCustomContextValue) {
    const ctx = createContext(null);
    const Provider = ({children}) => {
        const ctxValue = useDataGridContextBase(dataGridName);
        const customValue = useCustomContextValue();
        const value = useMemo(() => ({...ctxValue, ...customValue}), [ctxValue, customValue]);
        return <ctx.Provider value={value}>{children}</ctx.Provider>;
    }
    return [ctx, Provider];
}
